if (!customElements.get('images-with-text-blocks')) {
  class imagesWithTextBlocks extends HTMLElement {
    constructor() {
      super();
    }

    initializeSwiper() {
      const swiperEl = this.querySelector('swiper-container');
      const swiperParams = {
        slidesPerView: 'auto',
        speed: 1500,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        spaceBetween: '16px',
        breakpoints: {
          768: {
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          1280: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: '24px'
          }
        },
        loop: false,
      };
      
      Object.assign(swiperEl, swiperParams);
      if(typeof swiperEl.initialize === 'function') swiperEl.initialize();
    }

    connectedCallback() {
      this.initializeSwiper();
    }
  }

  customElements.define('images-with-text-blocks', imagesWithTextBlocks);
}
